<template>
  <v-page page="Log" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <Spinner ref="spinner"></Spinner>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <v-layout justify-start row align-center mt-3 mb-3>
                  <v-flex align-center>
                    <div
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >
                      {{BAN !="all" ? logInfo.Account :""}}
                      {{ServiceId !="all" && logInfo.Service != "" ? ", "+logInfo.Service : ""}}
                      {{ChargeId !="all" && logInfo.Charge != "" ? ", " + logInfo.Charge : ""}}
                      {{BAN == "all" && ChargeId == "all" && ServiceId == "all"? "Audit Logs": "" | capitalize}}
                      <!-- {{BAN !="all"  ? "Account "+BAN: ""}}
                      {{ServiceId !="all" ? ", Service " + ServiceId : ""}}
                      {{ChargeId !="all" ? ", Charge " + ChargeId : ""}}
                      {{BAN == "all" && ChargeId == "all" && ServiceId == "all"? type + " Level Audit Logs": "" | capitalize}}-->
                    </div>
                  </v-flex>
                </v-layout>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3>
                  <v-flex align-center>
                    <v-tabs v-model="selectedTab" @change="changeLogType">
                      <v-tab
                        v-for="tab in tabs"
                        :key="tab.id"
                        style="font-size:20px!important;"
                      >{{ tab.name }}</v-tab>
                    </v-tabs>
                  </v-flex>
                  <!-- FILTERS -->
                  <v-flex align-center xs8 ml-5>
                    <v-layout row v-if="selectedTab ==0">
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlAccountType"
                          v-model="filters.AccountType"
                          item-text="Text"
                          item-value="Text"
                          label="Account Type"
                          clearable
                          @change="filterAccounts"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlAccountMessage"
                          v-model="filters.Message"
                          item-text="Text"
                          item-value="Text"
                          label="Message"
                          clearable
                          @change="filterAccounts"
                        ></v-autocomplete>
                      </v-flex>-->
                      <v-flex xs3>
                        <v-menu
                          v-model="dateAccount"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filters.Date"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterAccounts"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filters.Date"
                            @input="dateAccount = false"
                            @change="filterAccounts"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlUsername"
                          v-model="filters.Username"
                          item-text="Text"
                          item-value="Text"
                          label="User"
                          clearable
                          @change="filterAccounts"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex xs6 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterAccounts"
                          ></v-text-field>
                          <v-btn @click="filterAccounts" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                      <!-- <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportAccountLogToCSV"
                      >TO CSV</a>
                    </v-layout>
                      </v-flex>-->
                    </v-layout>
                    <v-layout row v-if="selectedTab ==1">
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlServiceType"
                          v-model="filtersService.ServiceType"
                          item-text="Text"
                          item-value="Text"
                          label="Service Type"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlServiceMessage"
                          v-model="filtersService.Message"
                          item-text="Text"
                          item-value="Text"
                          label="Message"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>-->
                      <v-flex xs3>
                        <v-menu
                          v-model="dateService"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filtersService.Date"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterServices"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filtersService.Date"
                            @input="dateService = false"
                            @change="filterServices"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlUsername"
                          v-model="filtersService.Username"
                          item-text="Text"
                          item-value="Text"
                          label="User"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex xs6 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="searchService"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterServices"
                          ></v-text-field>
                          <v-btn @click="filterServices" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="selectedTab ==2">
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlChargeType"
                          v-model="filtersCharge.ChargeType"
                          item-text="Text"
                          item-value="Text"
                          label="Charges Type"
                          clearable
                          @change="filterCharges"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlChargeMessage"
                          v-model="filtersCharge.Message"
                          item-text="Text"
                          item-value="Text"
                          label="Message"
                          clearable
                          @change="filterCharges"
                        ></v-autocomplete>
                      </v-flex>-->

                      <v-flex xs3>
                        <v-menu
                          v-model="dateCharge"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filtersCharge.Date"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterCharges"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filtersCharge.Date"
                            @input="dateCharge = false"
                            @change="filterCharges"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlUsername"
                          v-model="filtersCharge.Username"
                          item-text="Text"
                          item-value="Text"
                          label="User"
                          clearable
                          @change="filterCharges"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex xs6 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="searchCharge"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterCharges"
                          ></v-text-field>
                          <v-btn @click="filterCharges" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <a
                        style="text-decoration: none"
                        class="align-center mr-0"
                        @click="exportToCSV"
                      >TO CSV</a>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- <v-layout v-show="showResetBtn && !loading" justify-start row align-center mt-0 mb-0>
                  <v-flex align-center>
                    <div class="text-xs-left align-center" style="font-size: 20px; font-weight: 600;">Parent Account # {{ parentBAN }}</div>
                  </v-flex>
                </v-layout>-->
                <auditLogDetails ref="auditLogDetails"></auditLogDetails>

                <!-- ACCOUNT TABLE -->
                <v-data-table
                  v-if="this.selectedTab ==0"
                  :headers="headers"
                  :items="auditLogs"
                  :item-key="auditLogs.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight :queries="searchHighlight">{{ props.item["AccountBAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left pl-0 pr-2 cell-overflow">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["AccountName1"].trim() + (props.item["AccountName2"] ? props.item["AccountName2"].trim() : '') }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["AccountType"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{props.item["Message"]}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["Timestamp"] | formatDateTime }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["Username"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["LogDetails"] ? formatDetails_helper(props.item["LogDetails"]):""}}</text-highlight>
                      </td>

                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <router-link
                          v-if="props.item.ACSTAT != null"
                          style="text-decoration: none"
                          :to="openAuditDetailsRoute(props.item)"
                        >{{ props.item.ACSTAT != null ? "VIEW":"" }}</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="pagination.totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END ACCOUNT TABLE -->
                <!-- SERVICE TABLE -->
                <v-data-table
                  v-if="selectedTab==1"
                  :headers="headersService"
                  :items="auditLogsService"
                  :item-key="auditLogsService.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="paginationService"
                  :loading="loadingService"
                  :total-items="paginationService.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight
                            :queries="searchServiceHighlight"
                          >{{ props.item["AccountBAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left px-0 cell-overflow">
                        <text-highlight
                          :queries="searchServiceHighlight"
                        >{{ props.item["AccountName1"].trim() + (props.item["AccountName2"] ? props.item["AccountName2"].trim() : '') }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openServices(props.item)"
                        >
                          <text-highlight
                            :queries="searchServiceHighlight"
                          >{{ props.item["ServiceType"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchServiceHighlight">{{props.item["Message"]}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchServiceHighlight"
                        >{{ props.item["Timestamp"] | formatDateTime }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchServiceHighlight"
                        >{{ props.item["Username"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchServiceHighlight"
                        >{{ props.item["LogDetails"] ? formatDetails_helper(props.item["LogDetails"]):""}}</text-highlight>
                      </td>

                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <router-link
                          v-if="props.item.ACSTAT != null"
                          style="text-decoration: none"
                          :to="openAuditDetailsRoute(props.item)"
                        >{{ props.item.ACSTAT != null ? "VIEW":"" }}</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="paginationService.rowsPerPage" :totalRecords="paginationService.totalRecords" v-model="paginationService.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ searchService }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END SERVICE TABLE -->
                <!-- CHARGE TABLE -->
                <v-data-table
                  v-if="selectedTab==2"
                  :headers="headersCharge"
                  :items="auditLogsCharge"
                  :item-key="auditLogsCharge.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="paginationCharge"
                  :loading="loadingCharge"
                  :total-items="paginationCharge.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight
                            :queries="searchChargeHighlight"
                          >{{ props.item["AccountBAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left px-0 cell-overflow">
                        <text-highlight
                          :queries="searchChargeHighlight"
                        >{{ props.item["AccountName1"].trim() + (props.item["AccountName2"] ? props.item["AccountName2"].trim() : '') }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openCharges(props.item)"
                        >
                          <text-highlight
                            :queries="searchChargeHighlight"
                          >{{ props.item["ChargeType"] }}</text-highlight>
                        </router-link>
                      </td>
                      <!-- <td class="text-xs-left px-0">{{ props.item["Type"] }}</td> -->
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchChargeHighlight">{{props.item["Message"]}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchChargeHighlight"
                        >{{ props.item["Timestamp"] | formatDateTime }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchChargeHighlight"
                        >{{ props.item["Username"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchChargeHighlight"
                        >{{ props.item["LogDetails"] ? formatDetails_helper(props.item["LogDetails"]):""}}</text-highlight>
                      </td>

                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <router-link
                          v-if="props.item.ACSTAT != null"
                          style="text-decoration: none"
                         :to="openAuditDetailsRoute(props.item)"
                        >{{ props.item.ACSTAT != null ? "VIEW":"" }}</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="paginationCharge.rowsPerPage" :totalRecords="paginationCharge.totalRecords" v-model="paginationCharge.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ searchCharge }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END CHARGE TABLE -->

                <v-btn
                  color="primary"
                  @click="resetLogs"
                  v-show="(selectedTab == 0 && showResetBtn && !loading) ||(selectedTab == 1 && showResetBtnService && !loadingService) || (selectedTab == 2 && showResetBtnCharge && !loadingCharge)"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import auditLogDetails from "./LogDetails.vue";
import TextHighlight from "vue-text-highlight";
import Spinner from "../../components/Spinner.vue";
import "@/assets/css/main.css"
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Log",

  components: {
    VPage,
    auditLogDetails,
    "text-highlight": TextHighlight,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    searchService: "",
    searchCharge: "",

    searchHighlight: "",
    searchServiceHighlight: "",
    searchChargeHighlight: "",

    loading: true,
    loadingService: true,
    loadingCharge: true,

    showResetBtn: false,
    showResetBtnService: false,
    showResetBtnCharge: false,

    ddlElementType: [],
    ddlDescription: [],
    ddlService: [],
    ddlProvider: [],
    ddlStatus: [],

    filters: {
      // "AccountBAN": BAN
    },
    filtersService: {
      // "ServiceId": ServiceId != "all"? ServiceId : null
    },
    filtersCharge: {
      // "AccountBAN":BAN,
      // "ChargeId": ChargeId != "all"? ChargeId : null
    },

    filtersChanged: false,
    filtersChangedService: false,
    filtersChangedCharge: false,

    auditLogs: [],
    auditLogsService: [],
    auditLogsCharge: [],

    services: [],

    selectedTab: 0,
    type: "account",

    BAN: "",
    ServiceId: "",
    ChargeId: "",

    dateAccount: false,
    dateService: false,
    dateCharge: false,

    ddlAccountType: [],
    ddlServiceType: [],
    ddlChargeType: [],
    ddlUsername: [],
    //  ddlAccountMessage:[],
    //  ddlServiceMessage:[],
    //  ddlChargeMessage:[],
    logInfo: {},
    rowsPerPageItems: [30, 45, 60, 100],

    // Selected by default
    pagination: {
      rowsPerPage: 25,
      descending: true,
      sortBy: "Timestamp",
      page: 1
    },
    paginationService: {
      rowsPerPage: 25,
      descending: true,
      sortBy: "Timestamp",
      page: 1
    },
    paginationCharge: {
      rowsPerPage: 25,
      descending: true,
      sortBy: "Timestamp",
      page: 1
    },

    headers: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "23%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-2 font-weight-bold subheading sort-asc"
      },
      {
        text: "Account Type",
        value: "AccountType",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Message",
        value: "Message",
        // sortable: false,
        width: "22%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Timestamp",
        value: "Timestamp",
        // sortable: false,
        width: "14%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Username",
        value: "Username",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Details",
        value: "Details",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],
    headersService: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Service Type",
        value: "ServiceType",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Message",
        value: "Message",
        // sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Timestamp",
        value: "Timestamp",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Username",
        value: "Username",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Details",
        value: "Details",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],
    headersCharge: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Charge Type",
        value: "ChargeType",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Message",
        value: "Message",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Timestamp",
        value: "Timestamp",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Username",
        value: "Username",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Details",
        value: "Details",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],
    tabs: [
      { id: 1, name: "account" },
      { id: 2, name: "service" },
      { id: 3, name: "charge" }
    ]
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    },
    //   type(){
    //       var type = this.$route.params.Type
    //       return type},
    // BAN() {
    //   var BAN = this.$route.params.BAN;
    //    if (typeof BAN == 'undefined' || BAN == null){
    //        BAN = 'all'
    //         return BAN
    //    }
    //   return BAN;
    // },
    // ServiceId(){
    //     var ServiceId = this.$route.params.ServiceId
    //     if (typeof ServiceId == 'undefined' || ServiceId == null){
    //         ServiceId = 'all'
    //         return ServiceId
    //     }
    //     return ServiceId
    // },
    // ChargeId(){
    //     var ChargeId=this.$route.params.ChargeId
    //     if (typeof ChargeId == 'undefined' || ChargeId == null){
    //         ChargeId = 'all'
    //         return ChargeId
    //     }
    //     return ChargeId
    // },
    breadcrumb() {
      var breadcrumb = [
        {
          text: "Log",
          disabled: false,
          href: "#/log/" + this.type + "/all/all/all"
        },
        {
          text: this.BAN,
          disabled: true,
          href: "#/log/" + this.type + "/all/all/all"
        }
      ];
      return breadcrumb;
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query.Details != null && to.query.Type !=null && (to.path== from.path)) {
        var Details = to.query.Details;
        var Type = to.query.Type
        this.openAuditDetails({
          ACSTAT: Details,
          Type:Type
        });
      }
      next()
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    async initialize() {
      // this.filters = {};
      // this.filtersService = {};

      this.type = this.$route.params.Type;
      if (this.type == "account") {
        this.selectedTab = 0;
        this.loading = true;
      } else if (this.type == "service") {
        this.selectedTab = 1;
        this.loadingService = true;
      } else if (this.type == "charge") {
        this.selectedTab = 2;
      }

      var BAN = this.$route.params.BAN;
      if (typeof BAN == "undefined" || BAN == null) {
        BAN = "all";
      }
      this.BAN = BAN;

      var ServiceId = this.$route.params.ServiceId;
      if (typeof ServiceId == "undefined" || ServiceId == null) {
        ServiceId = "all";
      }
      this.ServiceId = ServiceId;

      var ChargeId = this.$route.params.ChargeId;
      if (typeof ChargeId == "undefined" || ChargeId == null) {
        ChargeId = "all";
      }
      this.ChargeId = ChargeId;

      if (this.ChargeId !== "all") {
        // alert(ChargeId)

        //init charge
        this.filtersCharge = {
          ChargeId: this.ChargeId
        };
        this.filtersChangedCharge = true;
        this.showResetBtnCharge = true;

        if (this.ServiceId !== "all") {
          // init service
          this.filtersService = {
            ServiceId: this.ServiceId
          };
          this.filtersChangedService = true;
          this.showResetBtnService = true;
        }
        if (this.BAN !== "all") {
          // init account
          this.filters = {
            AccountBAN: this.BAN
          };
          this.filtersChanged = true;
          this.showResetBtn = true;
          if (this.ServiceId == "all") {
            // init service
            this.filtersService = {
              AccountBAN: this.BAN
            };
          }
        }
      } else if (this.ServiceId !== "all") {
        // init service
        this.filtersService = {
          ServiceId: this.ServiceId
        };
        this.filtersChangedService = true;
        this.showResetBtnService = true;

        //init charge
        this.filtersCharge = {
          AccountBAN: this.BAN
        };
        this.filtersChangedCharge = true;
        this.showResetBtnCharge = true;

        if (this.BAN !== "all") {
          // init account
          this.filters = {
            AccountBAN: this.BAN
          };
          this.filtersChanged = true;
          this.showResetBtn = true;
        }
      } else if (this.BAN !== "all") {
        // init account
        this.filters = {
          AccountBAN: this.BAN
        };
        this.filtersChanged = true;
        this.showResetBtn = true;

        // init service
        this.filtersService = {
          AccountBAN: this.BAN
        };
        this.filtersChangedService = true;
        this.showResetBtnService = true;

        //init charge
        this.filtersCharge = {
          AccountBAN: this.BAN
        };
        this.filtersChangedCharge = true;
        this.showResetBtnCharge = true;
      } else {
        if (this.type == "account") {
          this.filters = {};
          this.filtersChanged = true;
          this.showResetBtn = false;
        } else if (this.type == "service") {
          this.filtersService = {};
          this.filtersChangedService = true;
          this.showResetBtnService = false;
        } else if (this.type == "charge") {
          this.filtersCharge = {};
          this.filtersChangedCharge = true;
          this.showResetBtnCharge = false;
        }
        this.breadcrumb[1].text = "all";
      }

      this.getDropDownLists();

      this.getLogInfo();

      await this.paginationUpdated();

       if (this.$route.query.Details != null && this.$route.query.Type !=null) {
        var Details = this.$route.query.Details;
        var Type = this.$route.query.Type
        this.openAuditDetails({
          ACSTAT: Details,
          Type:Type
        });
      }

      this.loading = false;
      this.loadingService = false;
      this.loadingCharge = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    getDropDownLists() {
      axios.get("/api/AuditLogs/GetLogDDLs/").then(res => {
        this.ddlAccountType = res.data.ddlAccountType;
        this.ddlServiceType = res.data.ddlServiceType;
        this.ddlChargeType = res.data.ddlChargeType;
        this.ddlUsername = res.data.ddlUsername;
        // this.ddlAccountMessage = res.data.ddlAccountMessage
        // this.ddlServiceMessage = res.data.ddlServiceMessage
        // this.ddlChargeMessage = res.data.ddlChargeMessage
      });
    },
    getLogInfo() {
      var BAN = this.BAN;
      var ServiceId = this.ServiceId;
      var ChargeId = this.ChargeId;
      axios
        .get(
          "/api/AuditLogs/GetLogInfo/" +
            (BAN !== "all" ? BAN : "") +
            "/" +
            (ServiceId !== "all" ? ServiceId : "") +
            "/" +
            (ChargeId !== "all" ? ChargeId : "")
        )
        .then(res => {
          this.logInfo = res.data;
        });
    },

    async resetLogs() {
      if (
        (typeof this.filters.AccountBAN == "undefined" ||
          this.filters.AccountBAN == null) &&
        (typeof this.filters.ServiceId == "undefined" ||
          this.filters.ServiceId == null) &&
        (typeof this.filters.ChargeId == "undefined" ||
          this.filters.ChargeId == null)
      ) {
      } else {
        this.filters.AccountBAN = null;
        this.filters.ServiceId = null;
        this.filters.ChargeId = null;
        this.filtersChanged = true;
      }
      if (
        (typeof this.filtersService.AccountBAN == "undefined" ||
          this.filtersService.AccountBAN == null) &&
        (typeof this.filtersService.ServiceId == "undefined" ||
          this.filtersService.ServiceId == null) &&
        (typeof this.filtersService.ChargeId == "undefined" ||
          this.filtersService.ChargeId == null)
      ) {
      } else {
        this.filtersService.AccountBAN = null;
        this.filtersService.ServiceId = null;
        this.filtersService.ChargeId = null;
        this.filtersChangedService = true;
      }
      if (
        (typeof this.filtersCharge.AccountBAN == "undefined" ||
          this.filtersCharge.AccountBAN == null) &&
        (typeof this.filtersCharge.ServiceId == "undefined" ||
          this.filtersCharge.ServiceId == null) &&
        (typeof this.filtersCharge.ChargeId == "undefined" ||
          this.filtersCharge.ChargeId == null)
      ) {
      } else {
        this.filtersCharge.AccountBAN = null;
        this.filtersCharge.ServiceId = null;
        this.filtersCharge.ChargeId = null;
        this.filtersChangedCharge = true;
      }

      if (this.type == "account") {
        this.loading = true;
        this.filters = {};
        this.search = "";
        this.searchHighlight = "";
      } else if (this.type == "service") {
        this.loadingService = true;
        this.filtersService = {};
        this.searchService = "";
        this.searchServiceHighlight = "";
      } else if (this.type == "charge") {
        this.loadingCharge = true;
        this.filtersCharge = {};
        this.searchCharge = "";
        this.searchChargeHighlight = "";
      }

      this.breadcrumb[1].text = "all";
      (this.BAN = "all"), (this.ServiceId = "all");
      this.ChargeId = "all";
      this.logInfo = {};

      this.$router.push("/log/" + this.type + "/all/all/all");

      await this.paginationUpdated();

      if (this.type == "account") {
        this.showResetBtn = false;
        this.loading = false;
      } else if (this.type == "service") {
        this.showResetBtnService = false;
        this.loadingService = false;
      } else if (this.type == "charge") {
        this.showResetBtnCharge = false;
        this.loadingCharge = false;
      }
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item.AccountBAN;
    },
    openServices(item) {
      return "/services/" + item.AccountBAN;
    },
    openCharges(item) {
      return "/charges/" + item.AccountBAN;
    },

    formatDetails_helper(arrayDetails) {
      var details = "";
      arrayDetails.forEach((value, index) => {
        details += value.ACCOLUMNNAME + ", ";
      });
      var detailsTrim = details.replace(/,\s*$/, "");
      return detailsTrim;
    },
    async openAuditDetails(auditLog) {
      if (auditLog.Type == "Account") {
       await this.$refs.auditLogDetails.openAccountAuditLogDetails(auditLog.ACSTAT);
      }
      if (auditLog.Type == "Service") {
        await this.$refs.auditLogDetails.openServiceAuditLogDetails(auditLog.ACSTAT);
      }
      if (auditLog.Type == "Charge") {
        await this.$refs.auditLogDetails.openChargeAuditLogDetails(auditLog.ACSTAT);
      }
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var oldQuery = Object.assign({}, query)
      this.$delete(oldQuery,'Details')
      this.$delete(oldQuery,'Type')
      this.$router.push({path:path, query:oldQuery})
    },
    openAuditDetailsRoute(item){
var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query


      var newQuery = Object.assign({}, query)
      newQuery.Details = item.ACSTAT
      newQuery.Type=item.Type
      return {path: path, query: newQuery}
    },
    async filterAccounts() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      await this.paginationUpdated();
    },
    async filterServices() {
      this.filtersChangedService = true;
      this.showResetBtnService = true;
      this.searchServiceHighlight = this.searchService;
      await this.paginationUpdated();
    },
    async filterCharges() {
      this.filtersChangedCharge = true;
      this.showResetBtnCharge = true;
      this.searchChargeHighlight = this.searchCharge;
      await this.paginationUpdated();
    },

    async paginationUpdated() {
      var type = await this.type;
      if (type == "account") {
        this.loading = true;
        await axios
          .post(
            "/api/AuditLogs/GetPagedLogList/",
            {
              postData: {
                pagination: this.pagination,
                filtersChanged: this.filtersChanged,
                filters: this.filters,
                search: this.search
              }
            },
            {
              headers: {
                "Content-type": "application/json"
              }
            }
          )
          .then(response => {
            this.auditLogs = response.data.AccountLog;
            this.pagination.totalRecords =
              response.data.pagination.totalRecords;
          });
        this.filtersChanged = false;
        this.loading = false;
      } else if (type == "service") {
        this.loadingService = true;
        await axios
          .post(
            "/api/AuditLogs/GetPagedServiceLogList/",
            // "/api/AuditLogs/TestPagedServiceLogList/",
            {
              postData: {
                pagination: this.paginationService,
                filtersChanged: this.filtersChangedService,
                filters: this.filtersService,
                search: this.searchService
              }
            },
            {
              headers: {
                "Content-type": "application/json"
              }
            }
          )
          .then(response => {
            this.auditLogsService = response.data.ServiceLog;
            this.paginationService.totalRecords =
              response.data.pagination.totalRecords;
          });
        this.filtersChangedService = false;
        this.loadingService = false;
      } else if (type == "charge") {
        this.loadingCharge = true;
        await axios
          .post(
            "/api/AuditLogs/GetPagedChargeLogList/",
            {
              postData: {
                pagination: this.paginationCharge,
                filtersChanged: this.filtersChangedCharge,
                filters: this.filtersCharge,
                search: this.searchCharge
              }
            },
            {
              headers: {
                "Content-type": "application/json"
              }
            }
          )
          .then(response => {
            this.auditLogsCharge = response.data.ChargeLog;
            this.paginationCharge.totalRecords =
              response.data.pagination.totalRecords;
          });
        this.filtersChangedCharge = false;
        this.loadingCharge = false;
      }
    },
    async changeLogType(val) {
      var selectedTab = this.selectedTab;
      var type = this.tabs[selectedTab].name;
      var BAN = this.BAN;
      var ServiceId = this.ServiceId;
      var ChargeId = this.ChargeId;
      //   if (type == "account") {
      //     BAN = await this.BANAccount
      //   } else if (type == "service") {
      //    BAN = await this.BANService
      //   } else if (type == "charge") {
      //     BAN= await this.BANCharge
      //   }
      await this.$router.push(
        "/log/" + type + "/" + BAN + "/" + ServiceId + "/" + ChargeId
      );

      this.type = await type;
      if (this.type == "account") {
        if (this.auditLogs.length == 0 || this.filtersChanged == true) {
          await this.paginationUpdated();
        }
        this.loading = false;
      } else if (this.type == "service") {
        if (
          this.auditLogsService.length == 0 ||
          this.filtersChangedService == true
        ) {
          await this.paginationUpdated();
        }
      } else if (this.type == "charge") {
        if (
          this.auditLogsCharge.length == 0 ||
          this.filtersChangedCharge == true
        ) {
          await this.paginationUpdated();
        }
      }
    },
    exportToCSV(item) {
      this.$refs.spinner.spinOn();
      var url;
      if (this.type == "account") {
        url = "/api/AuditLogs/AccountLogToCSV";
      } else if (this.type == "service") {
        url = "/api/AuditLogs/ServiceLogToCSV";
      } else if (this.type == "charge") {
        url = "/api/AuditLogs/ChargeLogToCSV";
      }

      axios({
        url: url,
        method: "POST",
        responseType: "blob",
        data: {
          postData: {
            pagination: this.paginationService,
            filtersChanged: this.filtersChangedService,
            filters: this.filtersService,
            search: this.searchService
          }
        }
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            this.type.charAt(0).toUpperCase() +
              this.type.slice(1) +
              "Log." +
              currentDate +
              ".csv"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}

/* table.v-table{
  table-layout: fixed;
} */
.cell-overflow {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
